var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-auto nav-logo"},[_c('b-link',{attrs:{"to":"/"}},[_c('b-img',{staticClass:"nav-logo",attrs:{"src":_vm.appLogoImage,"alt":"logo"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }